import { BettingRecordPayload, BettingRecordResponseType } from "./type";

export const bettingRecordApi = {
  async warge(_username: string, payload: BettingRecordPayload) {
    return {
      status: 0,
      msg: "Success",
      data: [],
      total: {
        win_loss: "0",
        bet_amount: "0",
        bet_amount_valid: "0",
        rebate: "0",
      },
      totalCount: 0,
      totalPages: 1,
      currentPage: payload?.page || 1,
      pageSize: payload?.size || 10,
    } as BettingRecordResponseType;
  },
};
